// extracted by mini-css-extract-plugin
export default {"card":"Card_card__rYVqN","cardTitle":"Card_cardTitle__f4-UN","imgSize":"Card_imgSize__9duDu"};